import React, {useEffect, useState} from 'react';
import cn from 'classnames';

interface ISearchBoxProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  isAutofcus?: boolean;
}

const FloatingSearchBox = ({
  label,
  inputValue,
  onChange,
  setInputValue,
  isAutofcus = false,
  ...props
}: ISearchBoxProps) => {
  const [hasText, setHasText] = useState<boolean>(inputValue?.length > 0);
  const [startType, setStartType] = useState<boolean>(false);

  useEffect(() => {
    setHasText(inputValue?.length > 0);
  }, [inputValue]);

  return (
    <div className="relative mt-4">
      <label
        className={cn('w-fit bg-white absolute right-3 px-1 transition-all', {
          'top-1/2 -translate-y-1/2': !hasText,
          '-top-3 text-farm-shop-500': hasText,
        })}
      >
        {label}
      </label>
      <input
        {...props}
        className={cn('h-12 border-2 outline-0 rounded px-3 w-full', {
          'border-farm-shop-500': hasText,
        })}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setStartType(true);
          onChange(e);
        }}
        onFocus={() => {
          setHasText(true);
        }}
        autoFocus={isAutofcus}
        value={inputValue}
      />
      {startType && hasText && (
        <i
          className="icon-nameremove-circle absolute left-3 top-1/2 -translate-y-1/2 text-xxl"
          onClick={() => setInputValue('')}
        />
      )}
    </div>
  );
};

export default FloatingSearchBox;
